import { Typography } from '@montugroup/design-system';
import { TextContainer } from './States.styles';

export const DuplicateTokenExistingAccount = () => {
  return (
    <TextContainer data-testid="pharmacist-escript-duplicate-token-existing-account">
      <Typography variant="subtitle1" fontWeight={600} sx={(theme) => ({ marginBottom: theme.spacing(6) })}>
        This token has already been used
      </Typography>
      <Typography>Please try adding a new token for your customer</Typography>
    </TextContainer>
  );
};
